export enum VerificationStatus {
  COMPLETE = 'complete',
  OPTIONAL = 'optional',
  REQUESTED = 'requested',
}
